/* eslint-disable @typescript-eslint/no-non-null-assertion */
export default function convertJsonToFormData(
  value: unknown,
  key = "",
  formData = new FormData()
): FormData {
  if (value === undefined || value === null) {
    return formData;
  }

  if (typeof value === "boolean") {
    formData.append(key, value === true ? "1" : "0");
  } else if (value instanceof Date) {
    formData.append(key, value.toISOString());
  } else if (value instanceof File || value instanceof Blob) {
    formData.append(key, value);
  } else if (value instanceof Array || value instanceof FileList) {
    for (let i = 0; i < value.length; i += 1) {
      const combinedKey =
        typeof value[i] === "object" &&
        !(value[i] instanceof File || value[i] instanceof Blob)
          ? `${key}[${i}]`
          : key;

      convertJsonToFormData(value[i], combinedKey, formData);
    }
  } else if (typeof value === "string") {
    formData.append(key, value);
  } else if (typeof value === "number" || typeof value === "bigint") {
    formData.append(key, value.toString());
  } else if (typeof value === "object") {
    const objectEntries = Object.entries(value!);
    for (let i = 0; i < objectEntries.length; i += 1) {
      if (objectEntries[i] !== undefined && objectEntries[i] !== null) {
        const innerKey = objectEntries[i]![0];
        const innerValue = objectEntries[i]![1];
        const combinedKey =
          key === "" || key === undefined || key === null
            ? innerKey
            : `${key}.${innerKey}`;

        convertJsonToFormData(innerValue, combinedKey, formData);
      }
    }
  }

  return formData;
}
